import * as React from 'react';
import { Modal, Input } from 'antd';
import Form, { FormItem } from '../../../../../components/Form';
import CountrySelect from '../../../../../components/Others/CountrySelect';

interface IDeliverySettingsModalProps {
  order: GQL.IOrder;
  onSubmit: (data: any) => void;
  onClose: () => void;
}

interface IDeliverySettingsModalState {
  data: {
    deliveryFirstName: string | null;
    deliveryLastName: string | null;
    deliveryPhone: string | null;
    deliveryAddressLine1: string | null;
    deliveryAddressLine2: string | null;
    deliveryCity: string | null;
    deliveryZip: string | null;
    deliveryCountyState: string | null;
    deliveryCountry: string | null;
  };
}

class DeliverySettingsModal extends React.Component<IDeliverySettingsModalProps, IDeliverySettingsModalState> {

  private form;

  constructor(props: IDeliverySettingsModalProps) {
    super(props);

    this.state = {
      data: {
        deliveryFirstName: props.order.deliveryFirstName,
        deliveryLastName: props.order.deliveryLastName,
        deliveryPhone: props.order.deliveryPhone,
        deliveryAddressLine1: props.order.deliveryAddressLine1,
        deliveryAddressLine2: props.order.deliveryAddressLine2,
        deliveryCity: props.order.deliveryCity,
        deliveryZip: props.order.deliveryZip,
        deliveryCountyState: props.order.deliveryCountyState,
        deliveryCountry: props.order.deliveryCountry,
      },
    };

    this.form = React.createRef;

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  public render() {
    return (
      <div>
        <Modal
          title="Delivery settings"
          visible={true}
          okText={'Save changes'}
          onOk={this.onSubmit}
          onCancel={this.props.onClose}
          destroyOnClose={true}
          maskClosable={false}
        >
          <Form
            ref={f => this.form = f}
            displayFooter={false}
            onSubmit={this.onSubmit}
            onCancel={this.props.onClose}
          >
            <FormItem label={'First name'} required={true}>
              <Input
                name={'deliveryFirstName'}
                placeholder="Enter first name"
                value={this.state.data.deliveryFirstName || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Last name'} required={true}>
              <Input
                name={'deliveryLastName'}
                placeholder="Enter last name"
                value={this.state.data.deliveryLastName || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Phone'} required={true}>
              <Input
                name={'deliveryPhone'}
                placeholder="Enter delivery phone"
                value={this.state.data.deliveryPhone || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Street address'} required={true}>
              <Input
                name={'deliveryAddressLine1'}
                placeholder="Enter street address"
                value={this.state.data.deliveryAddressLine1 || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Address line 2'}>
              <Input
                name={'deliveryAddressLine2'}
                placeholder="Enter address line 2"
                value={this.state.data.deliveryAddressLine2 || ''}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'City'} required={true}>
              <Input
                name={'deliveryCity'}
                placeholder="Enter city"
                value={this.state.data.deliveryCity || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Zip'} required={true}>
              <Input
                name={'deliveryZip'}
                placeholder="Enter Zip code"
                value={this.state.data.deliveryZip || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'County / State'}>
              <Input
                name={'deliveryCountyState'}
                placeholder="Enter county / state"
                value={this.state.data.deliveryCountyState || ''}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Country'} required={true}>
              <CountrySelect
                name={'deliveryCountry'}
                value={this.state.data.deliveryCountry || ''}
                onChange={(e: any, country: GQL.ICountry) => this.onChange(e, country.name)}
              />
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }

  private onChange(e: any, val?: string) {
    const { name, value } = e.target;

    const inputValue = (val ? val : value);

    this.setState({
      data: { ...this.state.data, [name]: inputValue }
    });
  }

  private onSubmit() {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onSubmit(this.state.data);
      }
    }
  }
}

export default DeliverySettingsModal;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/DeliverySettings/components/Modal.tsx